__turbopack_context__.v({
  "active": "Unslider-module-scss-module__XkXB5q__active",
  "activeHero": "Unslider-module-scss-module__XkXB5q__activeHero",
  "blocksBackgroundColor": "Unslider-module-scss-module__XkXB5q__blocksBackgroundColor",
  "blocksFontColor": "Unslider-module-scss-module__XkXB5q__blocksFontColor",
  "container": "Unslider-module-scss-module__XkXB5q__container",
  "controls": "Unslider-module-scss-module__XkXB5q__controls",
  "indicator": "Unslider-module-scss-module__XkXB5q__indicator",
  "pause": "Unslider-module-scss-module__XkXB5q__pause",
  "secondaryNavBackgroundColor": "Unslider-module-scss-module__XkXB5q__secondaryNavBackgroundColor",
  "slide": "Unslider-module-scss-module__XkXB5q__slide",
  "slideContainer": "Unslider-module-scss-module__XkXB5q__slideContainer",
  "themeBackgroundColor": "Unslider-module-scss-module__XkXB5q__themeBackgroundColor",
  "themeFontColor": "Unslider-module-scss-module__XkXB5q__themeFontColor",
  "transitionEnter": "Unslider-module-scss-module__XkXB5q__transitionEnter",
  "transitionEnterActive": "Unslider-module-scss-module__XkXB5q__transitionEnterActive",
  "transitionEnterDone": "Unslider-module-scss-module__XkXB5q__transitionEnterDone",
  "transitionExit": "Unslider-module-scss-module__XkXB5q__transitionExit",
  "transitionExitActive": "Unslider-module-scss-module__XkXB5q__transitionExitActive",
  "transitionExitDone": "Unslider-module-scss-module__XkXB5q__transitionExitDone",
});
